import { render } from "./KYC.vue?vue&type=template&id=dfa09f66"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"

import "./KYC.vue?vue&type=style&index=0&id=dfa09f66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__